module.exports = __webpack_public_path__ + "static/media/btn-google-play.4645ec05.svg";